import type { ReactNode } from 'react';
import React, { Component } from 'react';

import { MapPageError } from './MapPageError';

type Props = { children: ReactNode };
type State = { hasError: boolean };

// noinspection JSUnusedLocalSymbols
export class MapPageErrorBoundary extends Component<any, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, node/handle-callback-err
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // eslint-disable-next-line node/handle-callback-err, @typescript-eslint/no-unused-vars
  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <MapPageError />;
      // You can render any custom fallback UI
    }

    return this.props.children;
  }
}
